import { getCmsNewsList } from "../../../app/api/getCMSNews";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  ICmsNewsResponse,
  ICMSNewsTypes,
} from "../../../Orchestrator/Types/Interface/ICMSNews";

class GetCmsNewsListAction extends BaseAction<ICMSNewsTypes[], void> {
  override async run(): Promise<ICMSNewsTypes[] | null> {
    let listOfNews: ICMSNewsTypes[] = [];
    try {
      const response: IApiResponse<ICmsNewsResponse> = await getCmsNewsList();

      if (response.status === "ok" && response.answer) {
        const newsArticles = response.answer.data;
        listOfNews = newsArticles;
        updateRecoilState("newsListResponseAtom", listOfNews);
      } else {
        console.warn("Failed to fetch News.");
      }
    } catch (error: any) {
      console.error("Error fetching News articles:", error);
    } finally {
      updateRecoilState("newsLoadedAtom", true);
      return listOfNews;
    }
  }
}

export const getCmsNewsListAction = new GetCmsNewsListAction();
